import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  CreateDoRequestActionOutput,
} from "../../lib";

import {
  doREQUEST_ERROR,
  doREQUEST_COMPLETE,
  doBATCH_SET,
  doREQUEST_SKIP,
  doPENDING_REQUEST_DELETE,
} from "../state";
import { checkRequestPending } from "./check_pending_request";
import { getToken } from "./token_fetcher";

export const REQUEST_BATCH_FETCH = "REQUEST_BATCH_FETCH";
export const doREQUEST_BATCH_FETCH =
  createDoRequestAction<RequestBatchFetchPayload>(REQUEST_BATCH_FETCH);

export const requestBatchFetchActionCreators = {
  doREQUEST_BATCH_FETCH,
};

export type RequestBatchFetchPayload = {
  batchId: string;
  page?: number;
  orderBy?: string;
  orderDescending?: boolean;
};

export function* requestBatchFetch({
  payload,
  setRequestResult,
}: CreateDoRequestActionOutput<RequestBatchFetchPayload>): SagaIterator {
  debug("saga*requestBatchFetch");

  const sameRequestPending = yield call(checkRequestPending, REQUEST_BATCH_FETCH, payload);
  if (sameRequestPending === true) {
    return yield put(
      doREQUEST_SKIP({
        fromType: REQUEST_BATCH_FETCH,
        requestId: payload.requestId,
      }),
    );
  }

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        batchId: v.string().uuid().exist(),
        page: v.number().optional(),
        orderBy: v.string().optional(),
        orderDescending: v.boolean(),
      }),
    });
  } catch (error) {
    yield put(
      doPENDING_REQUEST_DELETE({ requestType: REQUEST_BATCH_FETCH, requestId: payload.requestId }),
    );

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_BATCH_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { batchId, page, orderBy, orderDescending } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/batch-fetch`,
    accessToken,
    data: {
      batchId,
      page,
      orderBy,
      orderDescending,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    yield put(
      doPENDING_REQUEST_DELETE({ requestType: REQUEST_BATCH_FETCH, requestId: payload.requestId }),
    );

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_BATCH_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/batch-fetch",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doBATCH_SET(result.payload));

  yield put(
    doPENDING_REQUEST_DELETE({ requestType: REQUEST_BATCH_FETCH, requestId: payload.requestId }),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_BATCH_FETCH,
        requestId: payload.requestId,
        fromPayload: payload,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* batchFetchSaga() {
  yield takeEvery(REQUEST_BATCH_FETCH, requestBatchFetch);
}
